// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Qo","buttonPrev":"e_Ro","buttonNext":"e_So","hidden":"e_To","iconPrev":"e_Uo","iconNext":"e_Vo","scrollView":"e_Wo","card":"e_Xo","scroller":"e_Yo"};